import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const progress = current / total * 100;
  return <div className="w-full" data-id="element-40">
      <div className="flex justify-between items-center mb-3" data-id="element-41">
        <span className="text-xs text-white/40 tracking-widest uppercase" data-id="element-42">
          Pregunta
        </span>
        <span className="text-sm text-white/60 font-medium" data-id="element-43">
          {current}/{total}
        </span>
      </div>
      <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden" data-id="element-44">
        <motion.div className="h-full bg-gradient-to-r from-accent-pink to-accent-red" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-45" />
      </div>
    </div>;
}